import React, { AllHTMLAttributes } from 'react';
// import "../../../public/styles/icon.css";
/* 
  Attention: This file is generated by "yarn icon", do not modify 
*/

export enum IconClass {
  CARRIER_MENU = 'iconfont-carrier-menu',
  SALES_MENU = 'iconfont-sales-menu',
  NETWORK_MENU = 'iconfont-network-menu',
  LTL_ORDER = 'iconfont-ltl-order',
  QUOTE_ORDER = 'iconfont-quote-order',
  ADDRESS_MANAGEMENT = 'iconfont-address-management',
  EXPRESS_ORDER = 'iconfont-express-order',
  DOLOR_SYMBOL = 'iconfont-dolor-symbol',
  WALLET = 'iconfont-wallet',
  BAO = 'iconfont-bao',
  DOLOR = 'iconfont-dolor',
  WAYBILL_MENU = 'iconfont-waybill-menu',
  RECEIVE_ADDRESS = 'iconfont-receive-address',
  SEND_ADDRESS = 'iconfont-send-address',
  HOME_WEIGHT = 'iconfont-home-weight',
  HOME_WIDTH = 'iconfont-home-width',
  HOME_SMART = 'iconfont-home-smart',
  HOME_SAFETY = 'iconfont-home-safety',
  HOME_AFFORDABLE = 'iconfont-home-affordable',
  HOME_FLEXIBLE = 'iconfont-home-flexible',
  USER = 'iconfont-user',
  HOME_TRACKING = 'iconfont-home-tracking',
  HOME_ITEM = 'iconfont-home-item',
  CLOSE_O = 'iconfont-close-o',
  CLOSE_EYE = 'iconfont-close-eye',
  EYE = 'iconfont-eye',
  BACK_TOP = 'iconfont-back-top',
  RIGHT_O = 'iconfont-right-o',
  LEFT = 'iconfont-left',
  RIGHT = 'iconfont-right',
  SMILE = 'iconfont-smile',
  HOME_HEIGHT = 'iconfont-home-height',
  HOME_LENGTH = 'iconfont-home-length',
  HOME_CARGO = 'iconfont-home-cargo',
  HOME_LOCATION = 'iconfont-home-location',
  HOME_QRCODE = 'iconfont-home-qrcode',
  HOME_PHONE = 'iconfont-home-phone',
  HOME_AI = 'iconfont-home-ai',
  HOME_ADDRESS = 'iconfont-home-address',
  HOME_SCHEDULING = 'iconfont-home-scheduling',
  HOME_CUSTOMER_SERVICE = 'iconfont-home-customer-service',
  HOME_FRESH = 'iconfont-home-fresh',
  AVATAR = 'iconfont-avatar',
  CUSTOMER_MENU = 'iconfont-customer-menu',
  QUOTE_MENU = 'iconfont-quote-menu',
  SYSTEM_MENU = 'iconfont-system-menu',
  ORDER_MENU = 'iconfont-order-menu',
}

interface Props extends AllHTMLAttributes<HTMLElement | SVGSVGElement> {
  type: IconClass;
  symbol: boolean;
}

export default class Component extends React.PureComponent<Props> {
  static defaultProps = {
    symbol: false,
  };

  render() {
    const { type, symbol, className = '', style, ...restProps } = this.props;
    return symbol ? (
      <svg
        className={`iconfont ${className}`}
        style={{
          width: '1em',
          height: '1em',
          verticalAlign: '-0.15em',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        aria-hidden='true'
        {...restProps}
      >
        <use xlinkHref={`#${type}`} />
      </svg>
    ) : (
      <i className={`iconfont ${type} ${className}`} style={style} {...restProps} />
    );
  }
}
